/* ============================================================
 * Elara Voss — animaciones runtime
 * - Reveal al entrar en viewport (.ev-reveal -> .is-visible)
 * - Parallax suave en .ev-parallax (máx 20px)
 * Respeta prefers-reduced-motion.
 * ============================================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Reveal on scroll ---------------------------------------
  function initReveal() {
    var elements = document.querySelectorAll('.ev-reveal');
    if (!elements.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -60px 0px'
    });

    elements.forEach(function (el) { observer.observe(el); });
  }

  // --- Parallax suave -----------------------------------------
  function initParallax() {
    if (prefersReducedMotion) return;
    // En táctil (móvil/tablet) saltar parallax: iOS Safari + barra direcciones
    // colapsable provocan repaint constante al scroll → lagueo + cambios de altura.
    var isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    if (isTouch) return;
    var elements = document.querySelectorAll('.ev-parallax');
    if (!elements.length) return;

    var ticking = false;
    function update() {
      elements.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var viewportH = window.innerHeight;
        if (rect.bottom < 0 || rect.top > viewportH) return;
        var progress = (viewportH - rect.top) / (viewportH + rect.height);
        var offset = (progress - 0.5) * 40; // máximo ±20px
        offset = Math.max(-20, Math.min(20, offset));
        el.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  // --- FAQ acordeón: cierra los demás al abrir uno (opcional) -
  function initAccordion() {
    document.querySelectorAll('.ev-accordion').forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (!acc.open) return;
        var siblings = acc.parentElement
          ? acc.parentElement.querySelectorAll('.ev-accordion')
          : [];
        siblings.forEach(function (s) {
          if (s !== acc && s.open) s.open = false;
        });
      });
    });
  }

  // --- Congelar viewport height (--ev-vh) ---------------------
  // iOS Safari / Instagram in-app browser colapsan la barra de direcciones al
  // scrollear, lo que hace que 1vh cambie y provoque "lagueo" de altura. Lo
  // resolvemos calculando la altura UNA vez al cargar y solo recalculando en
  // rotación o resize real (NUNCA en scroll).
  function initVhLock() {
    var lockedWidth = window.innerWidth;
    function set() {
      document.documentElement.style.setProperty(
        '--ev-vh',
        (window.innerHeight * 0.01).toFixed(2) + 'px'
      );
    }
    set();
    // SOLO recalculamos si cambia el ANCHO (rotación, redimensión real).
    // Si solo cambia la altura → toolbar collapse de iOS/Instagram → ignorar.
    function onResize() {
      if (window.innerWidth !== lockedWidth) {
        lockedWidth = window.innerWidth;
        set();
      }
    }
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        lockedWidth = window.innerWidth;
        set();
      }, 200);
    });
    window.addEventListener('resize', onResize, { passive: true });
  }

  function initUrgencyStock() {
    var productForm = document.querySelector('product-form');
    if (!productForm) return;
    // Detectar on-sale: presencia de compare-at-price en el área del producto
    var compareAt = document.querySelector('main compare-at-price, .product-info compare-at-price, product-info compare-at-price');
    if (!compareAt) return;
    if (productForm.querySelector('.ev-urgency-stock')) return;
    var atc = productForm.querySelector('button[name="add"]');
    if (!atc) return;
    var insertTarget = atc.closest('.button-group, .buy-buttons, .product-form__buttons') || atc;
    var msg = (productForm.getAttribute('data-ev-urgency-text') || '').trim() || 'Quasi esaurito!';
    var urgency = document.createElement('div');
    urgency.className = 'ev-urgency-stock';
    urgency.innerHTML = '<span class="ev-urgency-stock__dot" aria-hidden="true"></span><span>' + msg + '</span>';
    insertTarget.parentNode.insertBefore(urgency, insertTarget);
  }

  function init() {
    initVhLock();
    initReveal();
    initParallax();
    initAccordion();
    initUrgencyStock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
 * EV — Free shipping bar: marca data-reached y progress %
 * El custom element del tema cambia los atributos total-price
 * y threshold pero no expone estado. Esto añade un atributo
 * data-reached cuando se llega al umbral y setea
 * --free-shipping-progress para que el CSS rellene la barra.
 * ============================================================ */
(function () {
  function update(bar) {
    var threshold = parseFloat(bar.getAttribute('threshold')) || 0;
    var total = parseFloat(bar.getAttribute('total-price')) || 0;
    var reached = threshold > 0 && total >= threshold;
    if (reached) bar.setAttribute('data-reached', '');
    else bar.removeAttribute('data-reached');
    var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;
    bar.style.setProperty('--free-shipping-progress', pct + '%');
  }
  function updateAll() {
    document.querySelectorAll('free-shipping-bar').forEach(update);
  }
  updateAll();
  // Observa cambios de atributos en cualquier free-shipping-bar (incluso al inyectarse vía AJAX cart-drawer refresh)
  var mo = new MutationObserver(function (mutations) {
    var seen = new Set();
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (t && t.tagName && t.tagName.toLowerCase() === 'free-shipping-bar' && !seen.has(t)) {
        seen.add(t);
        update(t);
      }
      // Si se añaden nuevos free-shipping-bar al DOM
      if (mutations[i].addedNodes) {
        mutations[i].addedNodes.forEach(function (n) {
          if (n.nodeType === 1) {
            if (n.tagName && n.tagName.toLowerCase() === 'free-shipping-bar') update(n);
            else if (n.querySelectorAll) n.querySelectorAll('free-shipping-bar').forEach(update);
          }
        });
      }
    }
  });
  mo.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['total-price', 'threshold']
  });
})();

/* ============================================================
 * EV — Fly to cart
 * Al añadir un producto, una miniatura de la imagen "vuela"
 * desde el producto hasta el icono del carrito en la cabecera.
 * El drawer lateral lo abre el tema solo (evento cart:change).
 * Respeta prefers-reduced-motion.
 * ============================================================ */
(function () {
  'use strict';
  // Nota: efecto solicitado explícitamente, se ejecuta aunque el usuario
  // tenga "Reducir movimiento" activado (es breve y suave).

  function visible(el) {
    return el && el.getClientRects().length > 0;
  }

  // URL de la imagen del producto (solo la textura del círculo)
  function findImageUrl(form) {
    var imgs = document.querySelectorAll(
      '.product-gallery__media:not([hidden]) img, .product-gallery img, .product-info img'
    );
    for (var i = 0; i < imgs.length; i++) {
      var u = imgs[i].currentSrc || imgs[i].src;
      if (u) return u;
    }
    var scope =
      form.closest('.product-card, .product-info, li, .shopify-section') || document;
    var img = scope.querySelector('img');
    return img ? img.currentSrc || img.src : '';
  }

  // Destino: icono del carrito (varios selectores por compatibilidad móvil)
  function getTarget() {
    var sels = [
      '.header__cart-link',
      'a[aria-controls="cart-drawer"]',
      '#cart-icon-bubble',
      'a[href$="/cart"]'
    ];
    for (var i = 0; i < sels.length; i++) {
      var els = document.querySelectorAll(sels[i]);
      for (var j = 0; j < els.length; j++) {
        if (visible(els[j])) return els[j];
      }
    }
    return null;
  }

  // El círculo sale del propio elemento pulsado (siempre visible)
  function fly(startEl, target, button, imgUrl) {
    if (button) button.classList.add('ev-atc-flying');

    // Velo oscuro para resaltar el círculo (fade in y fade out)
    var veil = document.createElement('div');
    veil.className = 'ev-fly-veil';
    document.body.appendChild(veil);
    veil.animate(
      [
        { opacity: 0 },
        { opacity: 1, offset: 0.25 },
        { opacity: 1, offset: 0.6 },
        { opacity: 0 }
      ],
      { duration: 800, easing: 'ease' }
    );

    var s = startEl.getBoundingClientRect();
    var t = target.getBoundingClientRect();
    var size = 72;
    var startX = s.left + s.width / 2;
    var startY = s.top + s.height / 2;
    var endX = t.left + t.width / 2;
    var endY = t.top + t.height / 2;
    var dx = endX - startX;
    var dy = endY - startY;

    var clone = document.createElement('div');
    clone.className = 'ev-fly-to-cart';
    if (imgUrl) clone.style.backgroundImage = 'url("' + imgUrl + '")';
    clone.style.width = size + 'px';
    clone.style.height = size + 'px';
    clone.style.left = startX - size / 2 + 'px';
    clone.style.top = startY - size / 2 + 'px';
    document.body.appendChild(clone);

    var anim = clone.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        {
          transform:
            'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 50) + 'px) scale(0.7)',
          opacity: 1,
          offset: 0.6
        },
        {
          transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.2)',
          opacity: 0.2
        }
      ],
      { duration: 800, easing: 'cubic-bezier(0.5, 0, 0.75, 0.5)', fill: 'forwards' }
    );

    anim.onfinish = function () {
      clone.remove();
      veil.remove();
      if (button) button.classList.remove('ev-atc-flying');
      target.classList.add('ev-cart-bump');
      setTimeout(function () {
        target.classList.remove('ev-cart-bump');
      }, 400);
    };
  }

  // Captura: se ejecuta antes del handler AJAX de <product-form>
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.closest || !form.closest('product-form')) return;
      var target = getTarget();
      if (!target) return;
      var button =
        event.submitter ||
        form.querySelector('button[name="add"], [type="submit"]');
      var startEl = button || form;
      fly(startEl, target, button, findImageUrl(form));
    },
    true
  );
})();
